import { PanelToggleMenuItem } from '../PanelToggle';

// (Pedro) — the session-meta header (path · name · auto-save · status · model) and the AGENTES
// (contexto) block were removed as clutter: the path/name/model already live in the session tab +
// composer, and the session's agent identity isn't something to surface here. The menu is now just
// the panel navigation.

/**
 * Menu lateral direito do chat (aba Code): sessão, agentes e painéis.
 */
export default function ChatRightMenu({
  groups,
  activePanelId,
  onPanelSelect,
}) {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto" data-testid="chat-right-menu">
      {groups.map((group) => (
        <section
          key={group.label}
          aria-label={group.label}
          className="border-b border-apolo-borderSubtle/60 px-1 py-2"
        >
          <p className="px-2 pb-0.5 text-[10px] font-semibold uppercase tracking-wider text-apolo-textTertiary">
            {group.label}
          </p>
          <ul>
            {group.tabs.map((tab) => (
              <li key={tab.id} role="none">
                <PanelToggleMenuItem
                  tab={tab}
                  active={activePanelId === tab.id}
                  onClick={() => onPanelSelect(tab.id)}
                />
              </li>
            ))}
          </ul>
        </section>
      ))}

      {/* (Pedro) — "Ações" section removed: Auto PR was a duplicate of the git
          bar's Criar PR, and "Abrir Canvas (diff)" duplicated the Canvas tab. */}
    </div>
  );
}
